import styled from "styled-components";

const IconPointer = styled.i`
  cursor: pointer;
`;

export default IconPointer;
